import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import ScrollToTop from "../common/scroll/ScrollToTop";
import NotFoundPage from "../pages/error/NotFoundPage";
import DashboardPage from "../pages/home/DashboardPage";
import { MyRequestsPage, RequestArchivePage, SubmitRequestPage } from "../pages/requests/index";
import RequestLetterPage from "../pages/requests/overview/letter/RequestLetterPage";
import RequestSupplementPage from "../pages/requests/overview/supplement/RequestSupplementPage";
import { cleanJoin } from "../utils/stringUtil";

function Page({ user }) {
  const location = useLocation();

  return (
    <main
      className={cleanJoin(
        "content mb-0 ",
        location.pathname === user.applicationConfiguration.dashboardUri ? "ml-4 mr-4 mt-4" : ""
      )}
    >
      <Switch>
        <Route exact path={user.applicationConfiguration.dashboardUri}>
          <DashboardPage />
        </Route>
        <Route exact path="/requests">
          <MyRequestsPage user={user} />
        </Route>
        <Route exact path={`/requests/:id/submissions/:uid/supplement`}>
          <RequestSupplementPage />
        </Route>
        <Route exact path={`/requests/:id/submissions/:uid/letter`}>
          <RequestLetterPage />
        </Route>
        <Route exact path="/submitRequest">
          <SubmitRequestPage user={user} />
        </Route>
        <Route exact path="/archive">
          <RequestArchivePage />
        </Route>
        <Route path="*">
          <NotFoundPage />
        </Route>
      </Switch>
      <ScrollToTop />
    </main>
  );
}

export default Page;
